import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { validateAndDecodeAuthToken } from '../utils/helper';

type RestrictedRouteProps = {
  restrictedToUserTypes: string[];
  children: ReactNode;
};

export const RestrictedRoute: FC<RestrictedRouteProps> = ({
  restrictedToUserTypes,
  children,
}) => {
  const validAuthToken = validateAndDecodeAuthToken();
  if (validAuthToken && restrictedToUserTypes.includes(validAuthToken.type)) {
    return <Navigate to="*" replace />;
  }
  return <>{children}</>;
};
